import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Code } from "./resetPassword/code";
import { NewPassword } from "./resetPassword/newPassword";

enum ResetPasswordStage {
  CODE,
  NEW_PASSWORD,
}

export function ResetPassword() {
  const {
    state: { email },
  }: { state: { email: string } } = useLocation();

  const [currentStage, setCurrentStage] = useState<ResetPasswordStage>(
    ResetPasswordStage.CODE,
  );
  const [code, setCode] = useState("");

  if (currentStage === ResetPasswordStage.CODE) {
    return (
      <Code
        nextStage={() => setCurrentStage(ResetPasswordStage.NEW_PASSWORD)}
        code={code}
        setCode={setCode}
      />
    );
  }

  return (
    <NewPassword
      onPreviousStage={() => setCurrentStage(ResetPasswordStage.CODE)}
      email={email}
      code={code}
    />
  );
}
